<div class="modal" *ngIf="isModalOpen | async">
    <div class="modal_backdrop" (click)="closeModal()"></div>
    <div class="card modal_content">
        <button (click)="closeModal()" type="button" class="btn_close">
            <span class="material-symbols-outlined">
                close
            </span>
        </button>
        <div class="card_body">
            <ng-content></ng-content>
        </div>
    </div>
</div>